<template>
  <div v-if="score" class="flex flex-col">
    <p class="text-14 lg:order-1">
      {{ $t('monito_score_description') }}
    </p>
    <ul class="py-4">
      <li class="py-2" v-for="category in score.categories" :key="category.name">
        <p class="tracking-wide font-semibold">
          {{ $t(`scores.category.${category.name}`) }}
        </p>
        <ScoreBar :score="category.value" />
      </li>
    </ul>
    <a
      v-if="reviewLink"
      :href="reviewLink"
      target="_blank"
      class="text-14 link mt-2 mb-4 lg:mt-4 lg:order-last"
      rel="noopener"
    >
      {{ $t('read_full_review') }}
    </a>
  </div>
  <div v-else class="text-14">
    {{ $t('no_score') }}
  </div>
</template>

<script lang="ts" setup>
import type { Provider } from './types'

defineProps<{
  score: Provider['score']
  reviewLink?: string | null
}>()
</script>
